import React, { Component } from "react";
import axios from "axios";
import { REACT_APP_BASE_URL } from "./constants";
import logo from "./logo.svg";

import mookh from "./mookh.png";
import "./App.css";

const flatten = (files, depth = 1) => {
  return files.reduce(
    (a, v) =>
      a.concat(depth > 1 && Array.isArray(v) ? flatten(v, depth - 1) : v),
    []
  );
};

const BASE_URL = REACT_APP_BASE_URL;
const BASE_DOWNLOAD_URL = `${BASE_URL}/stores/download`;

class App extends Component {
  state = {
    files: [],
    isFetching: false
  };

  pathName = (url, a) => {
    return ((a = document.createElement("a")),
    (a.href = url),
    a.pathname).replace("/", "");
  };

  componentDidMount() {
    const id = this.pathName(window.location.href);
    this.setState({ isFetching: true });
    axios
      .get(`${BASE_URL}/stores/orders/${id}/order_media_files/`)
      .then(res => {
        this.setState({ files: Object.values(res.data), isFetching: false });
      })
      .catch(() => {
        this.setState({ isFetching: false });
      });
  }

  testWhite = x => {
    var white = new RegExp(/^\s$/);
    return white.test(x.charAt(0));
  };
  wordWrap = (str, maxWidth) => {
    let newLineStr = "\n";

    let res = "";
    while (str.length > maxWidth) {
      let found = false;
      // Inserts new line at first whitespace of the line
      for (let i = maxWidth - 1; i >= 0; i--) {
        if (this.testWhite(str.charAt(i))) {
          res = res + [str.slice(0, i), newLineStr].join("");
          str = str.slice(i + 1);
          found = true;
          break;
        }
      }
      // Inserts new line at maxWidth position, the word is too long to wrap
      if (!found) {
        res += [str.slice(0, maxWidth), newLineStr].join("");
        str = str.slice(maxWidth);
      }
    }

    return res + str;
  };

  render() {
    const { files, isFetching } = this.state;
    return (
      <React.Fragment>
        <main>
          <img
            src={mookh}
            alt="mookh"
            style={{ marginBottom: 15, marginTop: 15 }}
          />
          <div className="Track_wrapper">
            <div className="logo_wrapper">
              <img src={logo} className="download_logo" alt="download" />
              <p>Please click the yellow button to download the files.</p>
            </div>
            {isFetching ? (
              <div className="loader-wrap">
                <div className="loader">Loading...</div>
              </div>
            ) : (
              <div className="list__wrap">
                <ul className="list__wrap__ul">
                  {flatten(files).map((file, index) => (
                    <li key={index}>
                      <p>{this.wordWrap(file.name, 20)}</p>
                      <a
                        className="list__wrap__a"
                        href={`${BASE_DOWNLOAD_URL}/${file.id}`}
                        download={file.name}
                      >
                        <img src={logo} alt="download" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </main>
        <footer>
          <a href="mailto:hello@mookh.africa">hello@mookh.africa</a>
        </footer>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js